/** Theme that user would like to use. */
export enum Theme {
  dark = 'dark',
  light = 'light'
}
